import router from 'next/router';
import { FC } from 'react';

import { Box, Button, Divider, Typography, Stack, useTheme } from '@mui/material';

import Container from '@components/store/container';
import { useBreakpointV2 } from '@helpers/use';
import { getAssetUrl } from '@helpers/utils';

type CertificateBundleCardProps = {
  bundle: {
    id: number;
    name: string;
    cardImage: string;
  };
  t: (key: string) => string;
};

const CertificateBundleCard: FC<CertificateBundleCardProps> = ({ bundle, t }) => {
  const { isDesktop } = useBreakpointV2();
  const theme = useTheme();
  return (
    <Stack gap={2}>
      <Container
        key={bundle.id}
        containerSx={{
          px: { xs: 3, md: 10, lg: 3 },
          display: 'grid',
          gridTemplateColumns: { md: '1fr 1fr', lg: '40% 1fr' },
          gap: { xs: 2, lg: 5 },
        }}
      >
        <Typography variant="subtitle1" color={theme.palette.primary.contrastText} noWrap>
          {t('course_detail.learning_path')}
        </Typography>
      </Container>
      <Container
        key={bundle.id}
        containerSx={{
          px: { xs: 3, md: 10, lg: 3 },
          display: 'grid',
          gridTemplateColumns: { md: '1fr 1fr', lg: '40% 1fr' },
          gap: { xs: 2, lg: 5 },
        }}
      >
        <Box
          component="img"
          src={bundle.cardImage ?? getAssetUrl('thumbnail-course-card.jpg')}
          width="100%"
          borderRadius={2}
          sx={{
            objectFit: 'cover',
          }}
        />
        <Stack spacing={2}>
          <Typography variant="h4" color="white">
            {bundle.name}
            <Divider sx={{ pt: 1, borderColor: 'white', opacity: 0.38 }} />
          </Typography>
          <Typography sx={{ opacity: 0.74 }} variant="body2_deprecated" whiteSpace="pre-line" color="white">
            <Typography sx={{ display: 'inline', marginBottom: 0 }} variant="h6" component="span" color="white">
              {t('course_detail.course_certificate_bundle.criteria_receive_certificate_bundle')}
            </Typography>
            <br /> {t('course_detail.course_certificate.criteria_receive_certificate.description')}
            <br /> {t('course_detail.course_certificate_bundle.criteria_receive_certificate_bundle.part1')}
            <br /> {t('course_detail.course_certificate_bundle.criteria_receive_certificate_bundle.part2')}
          </Typography>
          <Button
            sx={{ alignSelf: 'flex-start' }}
            variant="contained"
            color="secondary"
            fullWidth={!isDesktop}
            onClick={() => {
              router.push(`/learning-path/${bundle.id}`);
            }}
          >
            {t('course_detail.course_certificate.certificate_bundle_view_course')}
          </Button>
        </Stack>
      </Container>
    </Stack>
  );
};

export default CertificateBundleCard;
